import { v4 as uuidv4 } from 'uuid';

const SITE_URL = 'https://highline-apparel.com';

const uploadFile = async (file, orderId, type) => {
  try {
    console.log('Starting upload for:', file.name);
    
    const formData = new FormData();
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileName = `${orderId}_${type}_${uuidv4()}.${fileExtension}`;
    
    formData.append('file', file);
    formData.append('fileName', fileName);

    console.log('Sending request to:', `${SITE_URL}/upload.php`);
    
    const response = await fetch(`${SITE_URL}/upload.php`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
      mode: 'cors'
    });

    console.log('Response status:', response.status);
    const responseText = await response.text();
    console.log('Response text:', responseText);

    let result;
    try {
      result = JSON.parse(responseText);
    } catch (e) {
      console.error('Failed to parse response:', e);
      throw new Error('Invalid server response');
    }

    if (!result.success) {
      throw new Error(result.error || 'Upload failed');
    }

    return {
      originalName: file.name,
      uploadedPath: result.path,
      downloadURL: `${SITE_URL}/${result.path}`
    };
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const uploadFiles = async (files, orderId) => {
  const uploadedFiles = [];
  
  for (const file of files) {
    const result = await uploadFile(file, orderId, 'artwork');
    uploadedFiles.push(result);
  }
  
  return uploadedFiles;
};

export const uploadSnapshot = async (base64Image, orderId, type) => {
  try {
    // Convert base64 to blob
    const response = await fetch(base64Image);
    const blob = await response.blob();
    
    // Create a File object from the blob
    const file = new File([blob], `preview_${type}.png`, { type: 'image/png' });
    
    return await uploadFile(file, orderId, 'preview');
  } catch (error) {
    console.error('Preview upload error:', error);
    throw error;
  }
};